module.exports = __webpack_public_path__ + "img/product_pressalit_bathe_b.b130b4de.jpg";